// extracted by mini-css-extract-plugin
export default {"wrapper":"IbifB-pu5oX8lo+2p-QjOw==","title":"Cz1HRPA3DxuVJekP1SG10A==","shortcutContainer":"+1Aex6Y-ref-kdLZ85920A=="};